export default __webpack_public_path__ + "static/media/Lawlors.09bc1caf.jpg";